// GENERATE BY ./scripts/generate.ts
// DON NOT EDIT IT MANUALLY
import * as React from 'react';
import ThunderboltOutlinedSvg from "@ant-design/icons-svg/es/asn/ThunderboltOutlined";
import AntdIcon from '../components/AntdIcon';

var ThunderboltOutlined = function ThunderboltOutlined(props, ref) {
  return React.createElement(AntdIcon, Object.assign({}, props, {
    ref: ref,
    icon: ThunderboltOutlinedSvg
  }));
};

ThunderboltOutlined.displayName = 'ThunderboltOutlined';
export default React.forwardRef(ThunderboltOutlined);